/**
 * React Query 캐시 무효화 유틸리티
 */

import { queryClient } from '../../App';

/**
 * 게시판 관련 캐시 무효화
 * @param boardType - 게시판 타입 (news, gallery, bulletin, sunday-school)
 */
export const invalidateBoardCache = (boardType?: string) => {
  // 특정 게시판의 캐시만 무효화
  if (boardType) {
    queryClient.invalidateQueries({ queryKey: ['board', boardType] });
  } else {
    // 모든 게시판 캐시 무효화
    queryClient.invalidateQueries({ queryKey: ['board'] });
  }

  // 메인 페이지 최근 게시글 캐시도 무효화
  queryClient.invalidateQueries({ queryKey: ['recentPosts'] });
};

/**
 * 슬라이더 캐시 무효화
 */
export const invalidateSliderCache = () => {
  queryClient.invalidateQueries({ queryKey: ['sliders'] });
};

/**
 * 설교 영상 캐시 무효화
 * @param playlistType - 재생목록 타입 (sunday-morning, sunday-evening 등)
 */
export const invalidateSermonCache = (playlistType?: string) => {
  if (playlistType) {
    queryClient.invalidateQueries({ queryKey: ['sermons', playlistType] });
  } else {
    queryClient.invalidateQueries({ queryKey: ['sermons'] });
  }
};

/**
 * 모든 캐시 무효화
 */
export const invalidateAllCache = () => {
  queryClient.invalidateQueries();
};
